module.exports = __webpack_public_path__ + "static/media/shortA1ShortA2Pairs.ba2b19d0.mp3";